<template>
  <v-expansion-panels focusable>
    <v-expansion-panel>
      <v-expansion-panel-header class="titulo_buscador">
          <span>
            <v-icon class="mr-4">mdi-eye</v-icon> {{ $t('Términos de uso de Whatsapp en la app de gestión') }}
          </span>
      </v-expansion-panel-header>

      <v-expansion-panel-content>
        <v-row class="mt-0">
          <v-col cols="12">
            <h3><strong>{{ $t('Nueva funcionalidad APP gestión con WhatsApp.' ) }}</strong></h3>
          </v-col>

          <v-col cols="12">
            <p>
              {{ $t('Nuestra App de gestión en adelante te ofrecerá la posibilidad de poder comunicarte con tus clientes finales vía WhatsApp. En concreto, con la App de gestión será posible enviar recordatorios de citas y/o iniciar conversaciones privadas con tu cliente final. La contratación de la App de gestión se realizará de conformidad con nuestros' ) }} {{" "}}
              <a href="https://koibox.cloud/terms-of-use">{{ $t('Términos y Condiciones de Contratación') }}</a> {{ ". " }}
              {{ $t('El tratamiento de los datos personales de tus clientes, de los cuales eres responsables, con esta finalidad deberá realizarse en cumplimiento de la normativa de protección de datos aplicable.') }}
            </p>

            <p>
              <h3><strong>{{ $t('¿Cómo funcionará?' ) }}</strong></h3>
            </p>

            <p>
              {{ $t('Cuando uses la funcionalidad de WhatsApp en la App de gestión, estarás haciendo uso de la aplicación WhatsApp ya instalada en los móviles de las partes que participan en la conversación. Teniendo en cuenta la implicación de esta aplicación de terceros, desde KOIBOX te informamos que este servicio será prestado de conformidad con los' ) }} {{" "}}
              <a href="https://www.whatsapp.com/legal/terms-of-service/">{{ $t('Términos y Condiciones') }}</a> {{" "}}
              {{ $t('de WhatsApp. Estos Términos y Condiciones habrán sido aceptados por ti al momento de darte de alta como usuario en la aplicación WhatsApp. Tanto el uso que hagas de la funcionalidad “WhatsApp” de la App de gestión, como las implicaciones que esto pueda tener ante WhatsApp LLC, es completamente ajeno a KOIBOX y por tanto no podremos asumir ningún tipo de responsabilidad al respecto. Tampoco será responsabilidad de KOIBOX las incidencias que puedan darse en el marco de la prestación de los servicios de WhatsApp LLC. La posible infracción de los Términos y Condiciones de WhatsApp será gestionada de manera autónoma e independiente por WhatsApp LLC y puede llegar a implicar o bien que te bloqueen el usuario o que reporten el uso como SPAM, situación que puede conllevar incluso el bloqueo del uso total de WhatsApp en tu dispositivo móvil.' ) }}
            </p>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <ul class="my-3">
              <li><h4><strong>{{ $t('Recordatorios automáticos' ) }}</strong></h4></li>
            </ul>

            <p>{{ $t("La funcionalidad de envíos de mensajes recordatorios de cita con 24 horas de antelación a través de WhatsApp está integrada con la API de la compañía WhatsApp LLC, y para utilizar dicho servicio debes de estar de acuerdo con las") }} <a href="https://www.whatsapp.com/legal/business-terms" target="_blank">{{ $t("*Condiciones del servicio de WhatsApp Business") }}</a>.</p>
            <p>{{ $t("Consulta con WhatsApp LLC los costes por la utilización de este servicio en base a las conversaciones iniciadas por el usuario que utilice el servicio. Podéis ampliar información de las tarifas que aplique la compañía WhatsApp LLC en su página web o también en el enlace")}} <a href="https://developers.facebook.com/docs/whatsapp/pricing#rate-cards" target="_blank">{{$t('*Precios basados en conversaciones') }}</a>.</p>
            <p>{{ $t("La compañía Software Koibox SL no es responsable de las tarifas e importes cobrados desde la compañía WhatsApp LLC y Software Koibox SL solo cobra por la activación de la funcionalidad la tarifa vigente para los clientes con tarifas Lite y Basic") }}.</p>
            <p>{{ $t("El sistema manda los WhatsApp recordatorios de cita con 24 horas de antelación a la fecha  de la cita asignada, solo si la cita en cuestión ha sido asignada con más de un día de antelación y dicha cita no ha sido recordada y posteriormente modificada de fecha") }}.</p>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  name: "CondicionesContratacionWhatsapp",
}
</script>
